module.exports = __webpack_public_path__ + "static/feaarticle-190521115142-2-ad70f9cd70057a28a315762cf301bbcf.jpg";